module.exports = "/_next/static/images/logo_tarip-74928239dadaf08bb4c444188bf49da7.svg";